import React, { useEffect, useState } from "react";
import { Layout } from "../";
import {
  ComparisonStatTable,
  DateRangePicker,
  Loader,
  HistoryTeamSelector,
  PlayerStatsResume,
  PlayerStatsTable,
  PercentileChart,
} from "../../components";
import { Container, UpgradeContainer } from "./styled";
import { useLocation } from "react-router-dom";
import { calculatePercj, calculatePlayerStats } from "../../lib/cabbStats";
import { getPreviousSeason } from "../../lib/getPreviousSeason";
import { radarDataForPlayer } from "../../lib/radarData";
import { LeaguePlayersStats } from "../../lib/leaguePlayersStats";
import { Link } from "react-router-dom";
import { formatDate, unformatDate } from "../../lib/formatDate";
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";
import { Radar, Line } from "react-chartjs-2";
ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);
const ProfileStats = ({ appData }) => {
  const [activeProfile, setActiveProfile] = useState(null);
  const [games, setGames] = useState(null);
  const [gamesByLeague, setGamesByLeague] = useState(null);
  const [previousSeasonGameses, setPreviousSeasonGames] = useState(null);
  const [comparisonProfile, setComparisonProfile] = useState(null);
  const [isTeam, setIsTeam] = useState(null);
  const [dataSets, setDataSets] = useState(null);
  const [playerPercentile, setPlayerPercentaile] = useState([]);
  const [isSeasonSelecActive, setIsSeasonSelecActive] = useState(false);
  const [activeHistoryTeam, setActiveHistoryTeam] = useState(null);
  const [activePhase, setActivePhase] = useState(null);
  const [activeSeason, setActiveSeason] = useState(
    process.env.REACT_APP_ACTIVE_SEASON
  );
  const location = useLocation();
  const sessionUser = sessionStorage.getItem("user");
  const [isLoaded, setIsLoaded] = useState(false);
  let slug = location.pathname.replace("/statsProfile/", "");
  //FOR DATE PICKER
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  // FOR PLAYER
  const [activeGames, setActiveGames] = useState(null);
  const [playerGames, setPlayersGames] = useState(null);
  const [activeStatThroughoutSeasonValues, setctiveStatThroughoutSeasonValues] =
    useState(null);
  const [activeStatThroughoutSeason, setActiveStatThroughoutSeason] =
    useState("pts");
  const [comparisonStatThroughoutSeason, setComparisonThroughoutSeason] =
    useState(null);
  const [gamesPlayed, setGamesPlayed] = useState(null);
  const [totalPoints, setTotalPoints] = useState(null);
  const [totalAss, setTotalAss] = useState(null);
  const [avgPoints, setAvgPoints] = useState(null);
  const [totalMins, setTotalMins] = useState(null);
  const [made1pts, setMade1pts] = useState(null);
  const [made2pts, setMade2pts] = useState(null);
  const [made3pts, setMade3pts] = useState(null);
  const [totalTl, settotalTl] = useState(null);
  const [total2pts, settotal2Pts] = useState(null);
  const [total3pts, settotal3pts] = useState(null);
  const [rebTot, setRebTot] = useState(null);
  const [offRebTot, setOffRebTot] = useState(null);
  const [torTot, setTortot] = useState(null);
  const [blkTot, setBlkTot] = useState(null);
  const [stlTot, setStlTot] = useState(null);
  const [recFoulsTot, setRecFoulsTot] = useState(null);
  const [madFoulsTot, setMadeFoulsTot] = useState(null);
  const [radarData, setRadarData] = useState(null);
  const [gamesWonByTeam, setGamesWonByTeam] = useState(0);
  // END FOR PLAYER
  useEffect(() => {
    setIsTeam(false);
  }, []);

  const fetchData = async (id, player) => {
    try {
      setIsLoaded(false);

      // Buscar el equipo completo
      const teamData = appData?.teams?.find((e) => e._id === id);
      if (!teamData) return;

      // Buscar la liga correspondiente a la temporada activa
      const teamLeagueForSeason =
        teamData.history?.find((h) => h.season === activeSeason)?.league ||
        teamData.league; // fallback por si no existe en history

      if (!teamLeagueForSeason) {
        setIsLoaded(true);
        return;
      }

      // Fetch de los partidos de la liga en esa temporada
      const response = await fetch(
        `https://deportactico-vercel-serverless.vercel.app/api/gamesByleague?season=${activeSeason}&league=${teamLeagueForSeason}`
      );
      const result = await response.json();

      setGames((prevGames) => {
        const newGames = result.filter(
          (g) => g.local_team === id || g.visit_team === id
        );
        return [...new Set([...(prevGames || []), ...newGames])];
      });

      setGamesByLeague((prevGames) => [...(prevGames || []), ...result]);
    } catch (error) {
      console.error("Error fetching games by league:", error);
    }

    // Obtener el equipo de la temporada anterior
    let previousEntry = player?.teams_history?.find(
      (item) => item.season === getPreviousSeason(activeSeason)
    );

    if (!previousEntry) {
      setIsLoaded(true);
      return;
    }

    const { teamId: previousTeam, season: previousSeason } = previousEntry;
    if (!previousTeam || !previousSeason) return;

    try {
      const response = await fetch(
        `https://deportactico-vercel-serverless.vercel.app/api/gamesByTeam?season=${previousSeason}&teamId=${previousTeam}`
      );
      const result = await response.json();
      setPreviousSeasonGames(result);
    } catch (error) {
      console.error("Error fetching games by team:", error);
    } finally {
      setIsLoaded(true);
    }
  };

  useEffect(() => {
    if (!appData.teams || !appData.players) return;

    setGames(null);
    setPreviousSeasonGames(null);

    const team = appData.teams.find((e) => e._id === slug);
    if (team) {
      setActiveProfile(team);
      setIsTeam(true);
      return;
    }

    const player = appData.players.find((e) => e._id === slug);
    if (player) {
      setActiveProfile(player);

      // Obtener todos los equipos del historial en la temporada activa
      const teamsInActiveSeason = player.teams_history
        .filter((item) => item.season === activeSeason)
        .map((item) => item.teamId);
      if (teamsInActiveSeason.length === 0) {
        setIsLoaded(true);
        return;
      }

      teamsInActiveSeason.forEach((teamId) => {
        fetchData(teamId, player);
      });
      setIsTeam(false);
    }
  }, [appData, slug, activeSeason]);

  useEffect(() => {
    if (activeProfile !== null) {
      const newData = {
        labels: [
          "Defensive Aggressiveness",
          "Offensive Aggressiveness",
          "Catch & Score",
          "Go-to guy",
          "Scoring",
          "Shooting",
          "Play-making",
        ],
        datasets: [
          {
            label:
              radarData?.some((v) => v > 0) && activeProfile
                ? `${activeProfile?.player_name} ${activeProfile?.player_lastname}`
                : "Sin datos disponibles",
            data: radarData || [0, 0, 0, 0, 0, 0, 0],
            backgroundColor: "rgba(255, 99, 132, 0.2)",
            borderColor: "rgba(255, 99, 132, 0.6)",
            borderWidth: 1,
            lineTension: 0.3,
            hoverBackgroundColor: "red",
          },
        ],
      };
      setDataSets(newData);
    }
  }, [radarData, activeProfile]);

  useEffect(() => {
    if (comparisonProfile !== null) {
      let player = appData.players.filter((e) => e._id === comparisonProfile);
      let gamesArr = [];
      if (startDate !== null && endDate !== null) {
        for (var i = 0; i < games?.length; i++) {
          if (
            games[i].local_team === player[0].active_team &&
            games[i].date >= startDate &&
            games[i].date <= endDate
          ) {
            const indexOfObject = games[i].local_stats.findIndex((object) => {
              return object.player_id === comparisonProfile;
            });
            if (indexOfObject > -1) {
              gamesArr.push(games[i].local_stats[indexOfObject]);
            }
          } else if (
            games[i].visit_team === player[0].active_team &&
            games[i].date >= startDate &&
            games[i].date <= endDate
          ) {
            const indexOfObject = games[i].visit_stats.findIndex((object) => {
              return object.player_id === comparisonProfile;
            });
            if (indexOfObject > -1) {
              gamesArr.push(games[i].visit_stats[indexOfObject]);
            }
          }
        }
      } else {
        for (var i = 0; i < games?.length; i++) {
          if (
            games[i].local_team === player[0].active_team &&
            games[i].season === activeSeason
          ) {
            const indexOfObject = games[i].local_stats.findIndex((object) => {
              return object.player_id === comparisonProfile;
            });
            if (indexOfObject > -1) {
              gamesArr.push(games[i].local_stats[indexOfObject]);
            }
          } else if (
            games[i].visit_team === player[0].active_team &&
            games[i].season === activeSeason
          ) {
            const indexOfObject = games[i].visit_stats.findIndex((object) => {
              return object.player_id === comparisonProfile;
            });
            if (indexOfObject > -1) {
              gamesArr.push(games[i].visit_stats[indexOfObject]);
            }
          }
        }
      }
      let activeGames = [];
      let teamsArr = [];
      let playersArr = [];
      let filteredValue = appData.teams.filter(
        (e) => e._id === player[0].active_team
      );
      games?.forEach((element) => {
        if (
          element.season === activeSeason &&
          element.category === filteredValue[0].league
        ) {
          activeGames.push(element);
        }
      });
      appData.teams?.forEach((element) => {
        if (element.league === filteredValue[0].league) {
          teamsArr.push(element._id);
        }
      });
      appData.players?.forEach((element) => {
        if (teamsArr.includes(element.active_team)) {
          playersArr.push({
            _id: element._id,
            name: `${element.player_name} ${element.player_lastname}`,
            value: calculatePlayerStats(activeGames, element._id, "PTS"),
          });
        }
      });
      playersArr.sort((a, b) => b.value - a.value);
      const newData = {
        labels: [
          "Defensive Aggressiveness",
          "Offensive Aggressiveness",
          "Catch & Score",
          "Go-to guy",
          "Scoring",
          "Shooting",
          "Play-making",
        ],
        datasets: [
          {
            label: `${activeProfile?.player_name} ${activeProfile?.player_lastname}`,
            data: radarData,
            backgroundColor: "rgba(255, 99, 132, 0.2)",
            borderColor: "rgba(255, 99, 132, 0.6)",
            borderWidth: 1,
            lineTension: 0.3,
            hoverBackgroundColor: "red",
          },
          {
            label: `${player[0]?.player_name} ${player[0]?.player_lastname}`,
            data: radarDataForPlayer(gamesArr, player, playersArr, activeGames),
            backgroundColor: "rgba(0, 0, 0, 0.2)",
            borderColor: "rgba(0, 0, 0, 0.6)",
            borderWidth: 1,
            lineTension: 0.3,
            hoverBackgroundColor: "black",
          },
        ],
      };
      setDataSets(newData);
    }

    const statFields = [
      "FTP",
      "TWOOPP",
      "THREEPP",
      "ASS",
      "TO",
      "REB",
      "BLK",
      "STL",
      "eFG",
      "OREB",
      "FTR",
      "TOR",
    ];
    const percentiles = {};

    statFields.forEach((field) => {
      const stats = LeaguePlayersStats(
        appData.players,
        games,
        activeSeason,
        appData.teams,
        activeProfile,
        field,
        activeHistoryTeam
      );

      const index = stats.findIndex((p) => p._id === slug);
      if (index >= 0 && stats.length > 0) {
        percentiles[field] = ((index / stats.length) * 100).toFixed(1);
      } else {
        percentiles[field] = null;
      }
    });

    setPlayerPercentaile({
      ftPercentile: percentiles["FTP"],
      twoPercentile: percentiles["TWOOPP"],
      threePercentile: percentiles["THREEPP"],
      assistPercentile: percentiles["ASS"],
      turnoverPercentile: percentiles["TO"],
      reboundingPercentile: percentiles["REB"],
      blockPercentile: percentiles["BLK"],
      stealsPercentile: percentiles["STL"],
      eFGPercentile: percentiles["eFG"],
      OREBPercentile: percentiles["OREB"],
      FTRPercentile: percentiles["FTR"],
      TORPercentile: percentiles["TOR"],
    });
  }, [comparisonProfile, activeGames]);

  useEffect(() => {
    if (
      activeProfile !== null &&
      games !== null &&
      activeHistoryTeam !== null
    ) {
      let gamesArr = [];

      let teamsHistory = activeProfile.teams_history
        .filter((item) => item.season === activeSeason)
        .map((team) => team.teamId);

      // --- Caso 1: Rango de fechas ---
      if (startDate !== null && endDate !== null) {
        for (let i = 0; i < games.length; i++) {
          const currentGame = games[i];
          const date = unformatDate(currentGame.date);

          if (
            ((activeHistoryTeam === null &&
              teamsHistory.includes(currentGame.local_team)) ||
              activeHistoryTeam === currentGame.local_team) &&
            date >= startDate &&
            date <= endDate
          ) {
            const idx = currentGame.local_stats.findIndex(
              (obj) => obj.player_id === slug
            );
            if (idx > -1) {
              gamesArr.push({
                stat: currentGame.local_stats[idx],
                game: currentGame,
              });
            }
          } else if (
            ((activeHistoryTeam === null &&
              teamsHistory.includes(currentGame.visit_team)) ||
              activeHistoryTeam === currentGame.visit_team) &&
            date >= startDate &&
            date <= endDate
          ) {
            const idx = currentGame.visit_stats.findIndex(
              (obj) => obj.player_id === slug
            );
            if (idx > -1) {
              gamesArr.push({
                stat: currentGame.visit_stats[idx],
                game: currentGame,
              });
            }
          }
        }
      } else if (
        startDate === null &&
        endDate === null &&
        activeSeason !== null &&
        activeHistoryTeam === "season"
      ) {
        for (let index = 0; index < games.length; index++) {
          const currentGame = games[index];
          const isActivePhase =
            activePhase === null || currentGame.stage === activePhase;

          if (
            teamsHistory.includes(currentGame.local_team) &&
            currentGame.season === activeSeason &&
            isActivePhase
          ) {
            const idx = currentGame.local_stats.findIndex(
              (obj) => obj.player_id === slug
            );
            if (
              idx > -1 &&
              Number(currentGame.local_stats[idx].mins.replace(":", ".")) > 0
            ) {
              gamesArr.push({
                stat: currentGame.local_stats[idx],
                game: currentGame,
              });
            }
          } else if (
            teamsHistory.includes(currentGame.visit_team) &&
            currentGame.season === activeSeason &&
            isActivePhase
          ) {
            const idx = currentGame.visit_stats.findIndex(
              (obj) => obj.player_id === slug
            );
            if (
              idx > -1 &&
              Number(currentGame.visit_stats[idx].mins.replace(":", ".")) > 0
            ) {
              gamesArr.push({
                stat: currentGame.visit_stats[idx],
                game: currentGame,
              });
            }
          }
        }
      } else if (startDate === null && endDate === null) {
        for (let index = 0; index < games.length; index++) {
          const currentGame = games[index];
          const isActivePhase =
            activePhase === null || currentGame.stage === activePhase;

          if (
            activeHistoryTeam === currentGame.local_team &&
            currentGame.season === activeSeason &&
            isActivePhase
          ) {
            const idx = currentGame.local_stats.findIndex(
              (obj) => obj.player_id === slug
            );
            if (
              idx > -1 &&
              Number(currentGame.local_stats[idx].mins.replace(":", ".")) > 0
            ) {
              gamesArr.push({
                stat: currentGame.local_stats[idx],
                game: currentGame,
              });
            }
          } else if (
            activeHistoryTeam === currentGame.visit_team &&
            currentGame.season === activeSeason &&
            isActivePhase
          ) {
            const idx = currentGame.visit_stats.findIndex(
              (obj) => obj.player_id === slug
            );
            if (
              idx > -1 &&
              Number(currentGame.visit_stats[idx].mins.replace(":", ".")) > 0
            ) {
              gamesArr.push({
                stat: currentGame.visit_stats[idx],
                game: currentGame,
              });
            }
          }
        }
      }

      // --- DEDUPLICACIÓN POR ID DE PARTIDO ---
      const seenGameIds = new Set();
      const dedupedStats = [];
      const dedupedGames = [];

      for (const { stat, game } of gamesArr) {
        const gameId = game._id.toString();
        if (!seenGameIds.has(gameId)) {
          seenGameIds.add(gameId);
          dedupedStats.push(stat);
          dedupedGames.push(game);
        }
      }

      setPlayersGames(dedupedStats);
      getGamesScore(dedupedGames);
      setActiveGames(dedupedGames);
    }
  }, [
    games,
    activeProfile,
    startDate,
    endDate,
    slug,
    activePhase,
    activeSeason,
    activeHistoryTeam,
  ]);

  useEffect(() => {
    if (playerGames !== null) {
      sumPts();
    }
  }, [playerGames]);

  useEffect(() => {
    if (offRebTot !== null) {
      setDataForRadar();
    }
  }, [offRebTot, activeGames]);

  const formatMinutes = (time) => time.replace(/:/g, ".");

  useEffect(() => {
    handleChangeSeasonStat();
  }, [activeGames, activeStatThroughoutSeason, comparisonStatThroughoutSeason]);

  function handleChangeSeasonStat() {
    let activeValue = [];
    let comparisonValue = [];
    activeGames?.forEach((element) => {
      const seasonTeams = activeProfile.teams_history
        .filter((item) => item.season === activeSeason)
        .map((item) => item.teamId);

      const getPlayerStat = (teamStats, statKey) => {
        const player = teamStats.find(
          (player) => player.player_id === activeProfile._id
        );
        if (!player) return null;

        if (statKey === "pts") return player["pts"];
        if (statKey === "mins") return player["mins"];
        if (statKey === "tlA/I") {
          const [made, attempted] = player["tlA/I"].split("/").map(Number);
          return isNaN(made / attempted)
            ? 0
            : ((made / attempted) * 100).toFixed(2);
        }
        if (statKey === "tiros libres lanzados")
          return player["tlA/I"].split("/").map(Number)[1];
        if (statKey === "tiros libres convertidos")
          return player["tlA/I"].split("/").map(Number)[0];
        if (statKey === "2pA/I") {
          const [made, attempted] = player["2pA/I"].split("/").map(Number);
          return isNaN(made / attempted)
            ? 0
            : ((made / attempted) * 100).toFixed(2);
        }
        if (statKey === "dobles lanzados")
          return player["2pA/I"].split("/").map(Number)[1];
        if (statKey === "dobles convertidos")
          return player["2pA/I"].split("/").map(Number)[0];
        if (statKey === "3pA/I") {
          const [made, attempted] = player["3pA/I"].split("/").map(Number);
          return isNaN(made / attempted)
            ? 0
            : ((made / attempted) * 100).toFixed(2);
        }
        if (statKey === "triples lanzados")
          return player["3pA/I"].split("/").map(Number)[1];
        if (statKey === "triples convertidos")
          return player["3pA/I"].split("/").map(Number)[0];
        if (statKey === "rebOff") return player["rebOff"];
        if (statKey === "rebDef") return player["rebDef"];
        if (statKey === "rebTot") return player["rebTot"];
        if (statKey === "ass") return player["ass"];
        if (statKey === "per") return player["per"];
        if (statKey === "blocksMade") return player["blocksMade"];
        if (statKey === "blocksRecibed") return player["blocksRecibed"];
        if (statKey === "foulsMade") return player["foulsMade"];
        if (statKey === "foulesRecibed") return player["foulesRecibed"];

        return null;
      };

      // Procesar estadísticas según equipo local o visitante
      if (
        seasonTeams.includes(element.local_team) ||
        seasonTeams.includes(element.visit_team)
      ) {
        const isLocal = seasonTeams.includes(element.local_team);
        const teamStats = isLocal ? element.local_stats : element.visit_stats;

        const activeStatValue = getPlayerStat(
          teamStats,
          activeStatThroughoutSeason
        );
        const comparisonStatValue = getPlayerStat(
          teamStats,
          comparisonStatThroughoutSeason
        );

        if (activeStatValue !== null) {
          activeValue.push({
            location: isLocal ? "Local" : "Visita",
            game: element._id,
            date: element.date,
            value: activeStatValue,
          });
        }

        if (comparisonStatValue !== null) {
          comparisonValue.push({
            location: isLocal ? "Local" : "Visita",
            game: element._id,
            date: element.date,
            value: comparisonStatValue,
          });
        }
      }
    });

    // Construir datasets del gráfico
    const newData = {
      labels: activeValue.map((label) => label.date),
      datasets: [
        {
          label: `Estadísticas (${activeStatThroughoutSeason}) a lo largo de la temporada`,
          data: activeValue.map((label) =>
            typeof label.value === "string" && label.value.includes(":")
              ? formatMinutes(label.value)
              : label.value
          ),
          backgroundColor: "rgba(255, 99, 132, 0.2)",
          borderColor: "rgba(255, 99, 132, 0.6)",
          borderWidth: 1,
          lineTension: 0.3,
          hoverBackgroundColor: "red",
        },
        comparisonStatThroughoutSeason && {
          label: `Estadísticas (${comparisonStatThroughoutSeason}) a lo largo de la temporada`,
          data: comparisonValue.map((label) =>
            typeof label.value === "string" && label.value.includes(":")
              ? formatMinutes(label.value)
              : label.value
          ),
          backgroundColor: "rgba(54, 162, 235, 0.2)",
          borderColor: "rgba(54, 162, 235, 0.6)",
          borderWidth: 1,
          lineTension: 0.3,
          hoverBackgroundColor: "blue",
        },
      ].filter(Boolean),
    };

    setctiveStatThroughoutSeasonValues(newData);
  }

  const sumPts = async () => {
    let totalPts = 0;
    let totalAss = 0;
    let totalMins = 0;
    let gamesPlayed = 0;
    let total1pts = 0;
    let total2pts = 0;
    let total3pts = 0;
    let made1pts = 0;
    let made2pts = 0;
    let made3pts = 0;
    let rebTot = 0;
    let offRebTot = 0;
    let tor = 0;
    let stl = 0;
    let blk = 0;
    let recFouls = 0;
    let madeFouls = 0;
    let blocksRecibed = 0;
    let blocksMade = 0;
    let plusMinus = 0;

    for (var i = 0; i < playerGames.length; i++) {
      //points
      totalPts += Number(playerGames[i]["pts"]);
      //minutes
      let minutos = playerGames[i]["mins"].replace(":", ".");
      minutos.replace(":", ".");
      totalMins += Number(minutos);
      //assits
      totalAss += Number(playerGames[i]["ass"]);
      //games played
      if (Number(minutos) > 0) gamesPlayed += 1;
      //shotting %
      let tlPts = playerGames[i]["tlA/I"].split("/");
      total1pts += Number(tlPts[1]);
      made1pts += Number(tlPts[0]);
      let twoPts = playerGames[i]["2pA/I"].split("/");
      total2pts += Number(twoPts[1]);
      made2pts += Number(twoPts[0]);
      let trheePts = playerGames[i]["3pA/I"].split("/");
      total3pts += Number(trheePts[1]);
      made3pts += Number(trheePts[0]);
      //end of shooting %
      rebTot += Number(playerGames[i]["rebTot"]);
      offRebTot += Number(playerGames[i]["rebOff"]);
      stl += Number(playerGames[i]["rec"]);
      blk += Number(playerGames[i]["blocksMade"]);
      tor += Number(playerGames[i]["per"]);
      madeFouls += Number(playerGames[i]["foulsMade"]);
      recFouls += Number(playerGames[i]["foulesRecibed"]);
      blocksRecibed += Number(playerGames[i]["blocksRecibed"]);
      blocksMade += Number(playerGames[i]["blocksMade"]);
      plusMinus += Number(playerGames[i]["val"]);
    }

    setTotalPoints(totalPts);
    setGamesPlayed(gamesPlayed);
    setAvgPoints(Math.round((totalPts / gamesPlayed) * 10) / 10);
    setTotalMins(totalMins);
    setTotalAss(totalAss);
    settotalTl(total1pts);
    setMade1pts(made1pts);
    settotal2Pts(total2pts);
    setMade2pts(made2pts);
    settotal3pts(total3pts);
    setMade3pts(made3pts);
    setRebTot(rebTot);
    setBlkTot(blk);
    setStlTot(stl);
    setTortot(tor);
    setMadeFoulsTot(madeFouls);
    setRecFoulsTot(recFouls);
    setOffRebTot(offRebTot);
    setTimeout(() => {
      setIsLoaded(true);
    }, [3000]);
  };

  const setDataForRadar = () => {
    if (
      !activeGames ||
      !Array.isArray(activeGames) ||
      activeGames.length === 0
    ) {
      setRadarData([0, 0, 0, 0, 0, 0, 0]);
      return;
    }
    if (!appData?.teams || !appData?.players || !activeProfile) {
      setRadarData([0, 0, 0, 0, 0, 0, 0]);
      return;
    }
    let teamsArr = [];
    let playersArr = [];
    let filteredValue = isTeam
      ? appData.teams.filter((e) => e._id === activeProfile._id)
      : appData.teams.filter(
          (e) =>
            e._id ===
            activeProfile.teams_history.find(
              (item) => item.season === activeSeason
            )?.teamId
        );

    appData.teams?.forEach((element) => {
      if (element.league === filteredValue[0]?.league) {
        teamsArr.push(element._id);
      }
    });
    appData.players?.forEach((element) => {
      if (teamsArr.includes(element.active_team)) {
        playersArr.push({
          _id: element._id,
          name: `${element.player_name} ${element.player_lastname}`,
          value: calculatePlayerStats(activeGames, element._id, "PTS"),
        });
      }
    });

    playersArr.sort((a, b) => b.value - a.value);
    const playMaking = totalAss / torTot;
    let FG = made2pts + made3pts;
    let FGA = total2pts + total3pts;
    let EFG = Math.round(((FG + 0.5 * total3pts) / FGA) * 100);
    let TS = 0.5 * (totalPoints / FGA) + 0.44 * totalTl;
    let TSP = ((0.5 * totalPoints) / [FGA + 0.44 * totalTl]) * 100;
    const shooting = (EFG + TSP) / 2;
    let scorinig = ((totalPoints - 20) / (100 - 10)) * 100;
    let offensiveAggressiveness = recFoulsTot + offRebTot;
    let defensiveAggressiveness = stlTot + blkTot + madFoulsTot;

    let cAndS =
      (calculatePercj(
        activeGames,
        activeProfile.teams_history.find((item) => item.season === activeSeason)
          ?.teamId,
        "ASSTot"
      ) /
        FG) *
      10;
    let GtG =
      (totalMins *
        calculatePlayerStats(activeGames, activeProfile._id, "USG")) /
      calculatePercj(
        activeGames,
        activeProfile.teams_history.find((item) => item.season === activeSeason)
          ?.teamId,
        "POSSTot"
      );

    setRadarData([
      Math.round((defensiveAggressiveness / gamesPlayed) * 10),
      Math.round((offensiveAggressiveness / gamesPlayed) * 10),
      Math.round(
        cAndS >= 0 && cAndS <= 100
          ? cAndS
          : cAndS < 0
          ? 0
          : cAndS > 100
          ? 100
          : null
      ),
      Math.round(
        GtG * 10 >= 0 && GtG * 10 <= 100
          ? GtG * 10
          : GtG * 10 < 0
          ? 0
          : GtG * 10 > 100
          ? 100
          : null
      ),
      Math.round((avgPoints * 99) / playersArr[0]?.value),
      Math.round(shooting),
      Math.round(
        playMaking * 30 >= 0 && playMaking * 30 <= 100
          ? playMaking * 30
          : playMaking * 30 < 0
          ? 0
          : playMaking * 30 > 100
          ? 100
          : null
      ),
    ]);
  };

  const options = {
    responsive: true,
    hover: {
      backgroundColor: "rgba(255, 99, 132, 0.6)",
    },
    scales: {
      r: {
        suggestedMin: 10,
        suggestedMax: 100,
        max: 100,
      },
    },
  };

  const getGamesScore = (games) => {
    let wonGames = 0;
    const teamsInSeason = activeProfile.teams_history
      .filter((item) => item.season === activeSeason)
      .map((item) => item.teamId);

    for (let index = 0; index < games.length; index++) {
      let localTotalPts = 0;
      let visitTotalPts = 0;
      if (teamsInSeason.includes(games[index].local_team)) {
        games[index].local_stats.forEach((element) => {
          localTotalPts += element.pts;
        });
        games[index].visit_stats.forEach((element) => {
          visitTotalPts += element.pts;
        });
        if (localTotalPts > visitTotalPts) {
          wonGames++;
        }
      } else if (teamsInSeason.includes(games[index].visit_team)) {
        games[index].local_stats.forEach((element) => {
          localTotalPts += element.pts;
        });
        games[index].visit_stats.forEach((element) => {
          visitTotalPts += element.pts;
        });
        if (visitTotalPts > localTotalPts) {
          wonGames++;
        }
      }
    }
    setGamesWonByTeam(wonGames);
  };

  if (!isLoaded) {
    return <Loader />;
  }

  const handleStartDateChange = (e) => {
    setStartDate(e);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e);
  };

  const handleSelectChange = (value) => {
    const selectedOption = value;
    setIsSeasonSelecActive(!isSeasonSelecActive);
    // Add your logic here based on the selected option
    if (value === "custom date") {
      //show pop up
      let popUp = document.getElementById("date-pop-up");
      popUp.classList.add("active");
    } else {
      //show season data
      setStartDate(null);
      setEndDate(null);
    }
  };
  const seasons = activeProfile?.teams_history?.map(
    (history) => history.season
  );
  const uniqueSeasons = [...new Set(seasons)];

  return (
    <Layout isPositionUnset={true}>
      {sessionUser !== undefined &&
      sessionUser !== null &&
      sessionUser.plan !== "Basic" &&
      activeProfile !== null ? (
        <Container>
          <div className="navbar">
            <div className="navbar-content">
              <h3>Equipo:</h3>
              <HistoryTeamSelector
                appData={appData}
                activeProfile={activeProfile}
                activeSeason={activeSeason}
                setActiveHistoryTeam={setActiveHistoryTeam}
                activeHistoryTeam={activeHistoryTeam}
              />
            </div>
            <div className="navbar-content">
              <h3>Temporada:</h3>
              <div className="option season-container">
                <div
                  id="season-select"
                  onClick={(e) => {
                    setIsSeasonSelecActive(!isSeasonSelecActive);
                  }}
                >
                  {activeSeason !== null
                    ? activeSeason
                    : startDate !== null &&
                      endDate !== null &&
                      startDate !== null &&
                      endDate !== null
                    ? `${formatDate(startDate).DateFormatted}
                - ${formatDate(endDate).DateFormatted}`
                    : "Seleccionar"}
                </div>{" "}
                <div
                  className={`theme-select ${
                    isSeasonSelecActive ? "active" : null
                  }`}
                >
                  {uniqueSeasons.map((season, index) => (
                    <div
                      className="select-option"
                      onClick={(e) => {
                        setIsLoaded(false);
                        setActiveSeason(season);
                        setIsSeasonSelecActive(!isSeasonSelecActive);
                        setStartDate(null);
                        setEndDate(null);
                      }}
                    >
                      {season}
                    </div>
                  ))}
                  <div
                    className="select-option"
                    onClick={(e) => handleSelectChange("custom date")}
                  >
                    {startDate === null && endDate === null
                      ? "Periodo personalizado"
                      : `${formatDate(startDate).DateFormatted}
                  - ${formatDate(endDate).DateFormatted}`}
                  </div>
                </div>
                <div id="date-pop-up">
                  <DateRangePicker
                    onStartDateChange={handleStartDateChange}
                    onEndDateChange={handleEndDateChange}
                  />
                </div>
              </div>
            </div>
            <div className="navbar-content">
              <h3>Fase</h3>
              <select
                id="phase-select"
                onChange={(e) => {
                  e.target.value !== "Temporada completa"
                    ? setActivePhase(e.target.value)
                    : setActivePhase(null);
                }}
              >
                <option hidden defaultValue>
                  Selecciona Fase
                </option>
                <option>Temporada completa</option>
                <option>Fase regular</option>
                <option>Play in</option>
                <option>Reclasificación</option>
                <option>Playoff</option>
                <option>Permanencia</option>
              </select>
            </div>
            <div className="navbar-content">
              <Link
                className="btn-primary ghost"
                to={`/playerCard/${activeProfile._id}/season/${activeSeason}`}
              >
                Ver imagen
              </Link>
            </div>
          </div>
          <div className="container">
            <PlayerStatsResume
              activeProfile={activeProfile}
              activeGames={activeGames}
              previousSeasonGameses={previousSeasonGameses}
              gamesPlayed={gamesPlayed}
              activePhase={activePhase}
              activeSeason={activeSeason}
              startDate={startDate}
              endDate={endDate}
            />
            <ComparisonStatTable
              appData={appData}
              players={appData.players}
              activeGames={activeGames}
              activeProfileId={activeProfile._id}
              league={
                appData.teams.find((item) => item._id === activeHistoryTeam)
                  ?.league
              }
              activeSeason={activeSeason}
              gamesByLeague={gamesByLeague}
              setIsLoaded={setIsLoaded}
              teams={appData.teams}
              activeProfile={activeProfile}
              activeHistoryTeam={activeHistoryTeam}
            />
          </div>
          <div className="radar-chart_container">
            <PlayerStatsTable
              activeGames={activeGames}
              activeProfile={activeProfile}
              activeProfileId={activeProfile._id}
              playerGames={playerGames}
              gamesWonByTeam={gamesWonByTeam}
              gamesPlayed={gamesPlayed}
              gamesByLeague={gamesByLeague}
              activeSeason={activeSeason}
              activePhase={activePhase}
              activeHistoryTeam={activeHistoryTeam}
            />
            {dataSets !== null ? (
              <div className="radar-chart">
                <div className="flex_center_space-between">
                  <select
                    onChange={(e) => setComparisonProfile(e.target.value)}
                    className=""
                  >
                    <option value="">Compara con otro jugador</option>
                    {appData?.players !== null &&
                      appData?.players
                        .filter((player) => player.active_team !== "undefined")
                        .sort((a, b) => {
                          const fullNameA = `${a.player_name
                            ?.toUpperCase()
                            .trimStart()} ${a.player_lastname
                            ?.toUpperCase()
                            .trimStart()}`;
                          const fullNameB = `${b.player_name
                            ?.toUpperCase()
                            .trimStart()} ${b.player_lastname
                            ?.toUpperCase()
                            .trimStart()}`;
                          return fullNameA.localeCompare(fullNameB);
                        })
                        .map((player, index) => (
                          <option value={player._id}>
                            {`${player.player_name
                              ?.toUpperCase()
                              .trimStart()} ${player.player_lastname
                              ?.toUpperCase()
                              .trimStart()}`}
                          </option>
                        ))}
                  </select>
                </div>
                <Radar data={dataSets} options={options} />
              </div>
            ) : null}
          </div>
          <div className="percentile-chart-container">
            <div className="percentile-chart-container-extra">
              <h3>Lanzamientos</h3>
              <div className="percentile-chart-content">
                <div className="percentile-chart-text">
                  <div className="value-container">
                    <div className="value-content">
                      <p className="title">Tiro Libres</p>
                      <p className="value">{playerPercentile.ftPercentile}</p>
                    </div>
                    <div className="value-content">
                      <p className="title">2 Puntos</p>
                      <p className="value">{playerPercentile.twoPercentile}</p>
                    </div>
                    <div className="value-content">
                      <p className="title">3 Puntos</p>
                      <p className="value">
                        {playerPercentile.threePercentile}
                      </p>
                    </div>
                  </div>
                </div>
                <PercentileChart
                  data={{
                    ftPercentile: playerPercentile.ftPercentile,
                    twoPercentile: playerPercentile.twoPercentile,
                    threePercentile: playerPercentile.threePercentile,
                  }}
                />
              </div>
            </div>
            <div className="percentile-chart-container-extra">
              <h3>Manejo de Pelota</h3>
              <div className="percentile-chart-content">
                <div className="percentile-chart-text">
                  <div className="value-container">
                    <div className="value-content">
                      <p className="title">Asistencias</p>
                      <p className="value">{playerPercentile.ftPercentile}</p>
                    </div>
                    <div className="value-content">
                      <p className="title">Perdidas</p>
                      <p className="value">{playerPercentile.twoPercentile}</p>
                    </div>
                  </div>
                </div>
                <PercentileChart
                  data={{
                    assistPercentile: playerPercentile.assistPercentile,
                    turnoverPercentile: playerPercentile.turnoverPercentile,
                  }}
                />
              </div>
            </div>
            <div className="percentile-chart-container-extra">
              <h3>Defensa/Rebotes</h3>
              <div className="percentile-chart-content">
                <div className="percentile-chart-text">
                  <div className="value-container">
                    <div className="value-content">
                      <p className="title">Rebotes</p>
                      <p className="value">{playerPercentile.ftPercentile}</p>
                    </div>
                    <div className="value-content">
                      <p className="title">Tapas</p>
                      <p className="value">{playerPercentile.twoPercentile}</p>
                    </div>
                    <div className="value-content">
                      <p className="title">Recuperos</p>
                      <p className="value">
                        {playerPercentile.threePercentile}
                      </p>
                    </div>
                  </div>
                </div>
                <PercentileChart
                  data={{
                    reboundingPercentile: playerPercentile.reboundingPercentile,
                    blockPercentile:
                      playerPercentile.twoPercentblockPercentileile,
                    stealsPercentile: playerPercentile.stealsPercentile,
                  }}
                />
              </div>
            </div>
            <div className="percentile-chart-container-extra">
              <h3>4 Factores</h3>
              <div className="percentile-chart-content">
                <div className="percentile-chart-text">
                  <div className="value-container">
                    <div className="value-content">
                      <p className="title">eFG</p>
                      <p className="value">{playerPercentile.ftPercentile}</p>
                    </div>
                    <div className="value-content">
                      <p className="title">FTR</p>
                      <p className="value">{playerPercentile.twoPercentile}</p>
                    </div>
                    <div className="value-content">
                      <p className="title">OREB</p>
                      <p className="value">
                        {playerPercentile.threePercentile}
                      </p>
                    </div>
                    <div className="value-content">
                      <p className="title">TOR</p>
                      <p className="value">
                        {playerPercentile.threePercentile}
                      </p>
                    </div>
                  </div>
                </div>
                <PercentileChart
                  data={{
                    eFGPercentile: playerPercentile.eFGPercentile,
                    FTRPercentile: playerPercentile.FTRPercentile,
                    OREBPercentile: playerPercentile.OREBPercentile,
                    TORPercentile: playerPercentile.TORPercentile,
                  }}
                />
              </div>
            </div>
          </div>
          <div className="line-chart-stats">
            <div className="line-chart">
              <div className="header">
                <div className="navbar-content">
                  <select
                    onChange={(e) => {
                      setActiveStatThroughoutSeason(e.target.value);
                    }}
                    value={activeStatThroughoutSeason}
                  >
                    <option defaultValue value="pts">
                      Puntos
                    </option>
                    <option value="mins">Minutos jugados</option>
                    <option value="tiros libres lanzados">
                      Tiros libres lanzados
                    </option>
                    <option value="tiros libres convertidos">
                      Tiros libres convertidos
                    </option>
                    <option value="tlA/I">Porcentaje de tiros libres</option>

                    <option value="dobles lanzados">Dobles lanzados</option>

                    <option value="dobles convertidos">
                      Dobles convertidos
                    </option>
                    <option value="2pA/I">Porcentaje de dobles</option>
                    <option value="triples lanzados">Triples lanzados</option>
                    <option value="triples convertidos">
                      Triples convertidos
                    </option>
                    <option value="3pA/I">Porcentaje de triples</option>
                    <option value="rebOff">Rebotes ofensivos</option>
                    <option value="rebDef">Rebotes defensivos</option>
                    <option value="rebTot">Rebotes totales</option>
                    <option value="ass">Asistencias</option>
                    <option value="per">Perdidas</option>
                    <option value="blocksMade">Tapas cometidas</option>
                    <option value="blocksRecibed">Tapas recibidas</option>
                    <option value="foulsMade">Faltas cometidas</option>
                    <option value="foulesRecibed">Faltas recibidas</option>
                  </select>
                </div>
                <div className="navbar-content">
                  <select
                    onChange={(e) => {
                      setComparisonThroughoutSeason(e.target.value);
                    }}
                    value={comparisonStatThroughoutSeason}
                  >
                    <option defaultValue>Selecciona Estadistica</option>
                    <option value="pts">Puntos</option>
                    <option value="mins">Minutos jugados</option>
                    <option value="tiros libres lanzados">
                      Tiros libres lanzados
                    </option>
                    <option value="tiros libres convertidos">
                      Tiros libres convertidos
                    </option>
                    <option value="tlA/I">Porcentaje de tiros libres</option>

                    <option value="dobles lanzados">Dobles lanzados</option>

                    <option value="dobles convertidos">
                      Dobles convertidos
                    </option>
                    <option value="2pA/I">Porcentaje de dobles</option>
                    <option value="triples lanzados">Triples lanzados</option>
                    <option value="triples convertidos">
                      Triples convertidos
                    </option>
                    <option value="3pA/I">Porcentaje de triples</option>
                    <option value="rebOff">Rebotes ofensivos</option>
                    <option value="rebDef">Rebotes defensivos</option>
                    <option value="rebTot">Rebotes totales</option>
                    <option value="ass">Asistencias</option>
                    <option value="per">Perdidas</option>
                    <option value="blocksMade">Tapas cometidas</option>
                    <option value="blocksRecibed">Tapas recibidas</option>
                    <option value="foulsMade">Faltas cometidas</option>
                    <option value="foulesRecibed">Faltas recibidas</option>
                  </select>
                </div>
              </div>
              <div className="chart-container">
                <Line
                  className="line"
                  options={{
                    responsive: true,
                    plugins: {
                      title: {
                        display: false,
                      },
                    },
                  }}
                  data={activeStatThroughoutSeasonValues}
                />
              </div>
            </div>
          </div>
        </Container>
      ) : sessionUser && sessionUser?.plan === "Basic" ? (
        <UpgradeContainer>
          <h2 style={{ marginBottom: "0" }}>
            Herramienta solo para usuarios Premium
          </h2>
          <p>Actualiza tu susctipción ahora.</p>
          <div className="btns-container">
            <a className="btn-primary" href="/app/suscriptions">
              Ver suscripciones
            </a>
          </div>
        </UpgradeContainer>
      ) : (
        <UpgradeContainer>
          <h2 style={{ marginBottom: "0" }}>
            Graficas, analiticas personalisadas y más herramientas!
          </h2>
          <p>Contactate con ventas para tener más informacion.</p>
          <div className="btns-container">
            <a className="btn-primary" href="/app/suscriptions">
              CONTACTATE
            </a>
            <a className="btn-primary ghost" href="/app/login">
              INICIA SESIÓN
            </a>
          </div>
        </UpgradeContainer>
      )}
    </Layout>
  );
};

export default ProfileStats;
